import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { ICompanyResponse, ICompanyState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowROC = createAsyncThunk(
  'listCompanies/fetchShowROC',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.getROC(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: ICompanyState = {
  isLoading: false,
  response: null,
  error: null
}

const showROCSlice = createSlice({
  name: 'Companies/show',
  initialState,
  reducers: {
    resetShowROC: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowROC.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowROC.fulfilled, (state, action: PayloadAction<ICompanyResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowROC.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showROCSlice.reducer
export const { resetShowROC } = showROCSlice.actions
